import React from 'react';
import { makeStyles, Divider, Box, Grid, Avatar, Typography, Button, Paper } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { MdOutlineContentCopy } from "react-icons/md";

const useStyles = makeStyles((theme) => ({
    modalButtonBox: {
        "& button": {
            padding: "12px 0 !important",
            "&:hover": {
                border: "1px solid rgb(51, 153, 170)",
            },
            // "&:active": {
            //   background: "#6437C0 !important",
            //   boxShadow: "none !important",
            // },
        }
    },
    userProfileImage: {
        '& figure': {
            margin: "0px",
            width: "60px",
            height: "60px",
            // overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            '& img': {
                width: "100%",
                minHeight: "100%"
            }
        }
    }
}));


function UserProfileComponent() {
    const classes = useStyles();
    const history = useHistory();
    return (
        <>
            <Box className={classes.root} >
                <Box style={{ padding: "15px" }}>
                    <Grid container spacing={2} alignItems="center" justifyContent='center'>
                        <Grid item xs={3} align="center">
                            <Box className={classes.userProfileImage}>
                                <figure>
                                    <img alt="Travis Howard" src="images/user.png" />
                                </figure>
                            </Box>
                        </Grid>
                        <Grid item xs={9} align="left">
                            <Box mt={2} className="flexjustify">
                                <Typography variant="h6">
                                    0xc51s5aa...1eda&nbsp;
                                </Typography>
                                <MdOutlineContentCopy style={{
                                    color: "rgb(250, 145, 49)",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    marginLeft: "15px",
                                }} />
                            </Box>
                            <Typography variant="body1"
                                style={{ color: "#7784DA", }}>
                                Connected
                            </Typography>
                            <Box mt={1}>
                                <Typography variant="body2"
                                    style={{ color: "#7784DA", }}>
                                    Your Balanace
                                </Typography>
                            </Box>
                            <Grid container alignItems="center">
                                <Grid item xs={6} align="left">
                                    <Box className="flexjustify">
                                        <img src="images/balance.png" alt="image" />
                                        <Typography variant="h6"
                                            style={{
                                                fontSize: "15px",
                                                marginLeft: "3px",
                                            }}>
                                            0.004577
                                        </Typography>

                                    </Box>
                                </Grid>
                                <Grid item xs={6} align="left">
                                    <Typography variant="body2"
                                        style={{ color: "#7784DA", }}>
                                        ($0.00999)
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Divider />
                <Box style={{ padding: "15px" }}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={6} align="left">
                            <Box className={classes.modalButtonBox}>
                                <Button variant="contained" color="primary" fullWidth onClick={() => history.push("/my-account")}
                                >
                                    View profile
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={6} align="left">
                            <Box className={classes.modalButtonBox}>
                                <Button variant="contained" color="primary" fullWidth onClick={() => history.push("/wallet")}  >
                                    Wallet
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={6} align="left">
                            <Box className={classes.modalButtonBox}>
                                <Button variant="contained" color="primary" fullWidth onClick={() => history.push("/my-bets")} >
                                    My Bets
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={6} align="left">
                            <Box className={classes.modalButtonBox}>
                                <Button variant="contained" color="primary" fullWidth onClick={() => history.push("/transaction")} >
                                    Transaction
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    )
}

export default UserProfileComponent;